import autobind from '../../lib/autobind'
import React from 'react'

import DesktopNav from '../DesktopNav'
import MobileNav from '../MobileNav'

import '../../styles/navbar/styles.scss'

const MEDIA_QUERY = '(max-width: 949px)'

class Navigation extends React.Component {
  static renderDesktop () {
    return (<DesktopNav />)
  }

  static renderMobile () {
    return (<MobileNav />)
  }

  constructor (props) {
    super(props)
    autobind(this)
    this.state = {
      mobile: true
    }
  }

  updateNavigation ({ matches }) {
    this.setState({ mobile: matches })
  }

  componentDidMount () {
    if (window.matchMedia) {
      const mediaMatcher = matchMedia(MEDIA_QUERY)
      this.updateNavigation(mediaMatcher)
      mediaMatcher.addListener(this.updateNavigation)
    }
  }

  render () {
    return (
      <div className='navigation'>
        {
          this.state.mobile
            ? Navigation.renderMobile()
            : Navigation.renderDesktop()
        }
      </div>
    )
  }
}

export default Navigation
